var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSlides = function SvgSlides(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 9h-15A1.5 1.5 0 0 0 3 10.5v9A1.5 1.5 0 0 0 4.5 21h15a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 19.5 9m0 10.5h-15v-9h15zM4.5 6.75A.75.75 0 0 1 5.25 6h13.5a.75.75 0 1 1 0 1.5H5.25a.75.75 0 0 1-.75-.75m1.5-3A.75.75 0 0 1 6.75 3h10.5a.75.75 0 1 1 0 1.5H6.75A.75.75 0 0 1 6 3.75"
  })));
};
export default SvgSlides;